module.exports = __webpack_public_path__ + "static/img/home-on-48.6ecc5460.png";